import React from 'react';

import './ShortcutsBar.scss';
import { link } from '../../helpers/link';
import icons from '../../shared/assets/icons';

const { Subscribe } = icons;

export default function ShortcutsBar(props) {
  const { channel, tool, article } = props;

  return (
    <section id="shortcutsBar">
      <ul>
        <li className="shortcutsBar_item" id="shortcutsBar_channel">
          <img src={channel.imageUrl} alr="channel" />

          <div>
            <p>{channel.title}</p>

            <span>{channel.followers} volgers</span>
          </div>

          <button>
            <Subscribe />
            Abonneer
          </button>
        </li>

        <li className="shortcutsBar_item" id="shortcutsBar_tool">
          <img src={tool.imageUrl} alr="tool" />

          <p>{tool.title}</p>

          {link(<button>{tool.button.label}</button>, tool.button.link)}
        </li>

        <li className="shortcutsBar_item" id="shortcutsBar_article">
          <img src={article.imageUrl} alr="article" />

          <p>{article.title}</p>

          {link(<span>Lees verder</span>, article.link)}
        </li>
      </ul>
    </section>
  );
}
